var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 15.3333H15.3333V18.6667H28.6667V23.6667L37 17L28.6667 10.3333V15.3333ZM30.3333 27H25.82C23.8955 28.6972 21.5222 29.8031 18.9848 30.1849C16.4474 30.5667 13.8537 30.2082 11.515 29.1525C9.17627 28.0968 7.19186 26.3886 5.79988 24.233C4.40791 22.0774 3.6675 19.566 3.6675 17C3.6675 14.434 4.40791 11.9226 5.79988 9.76696C7.19186 7.61137 9.17627 5.90322 11.515 4.84748C13.8537 3.79174 16.4474 3.43327 18.9848 3.81508C21.5222 4.19689 23.8955 5.30276 25.82 6.99998H30.3333C28.7822 4.92861 26.7694 3.2475 24.4549 2.09022C22.1403 0.932939 19.5878 0.331374 17 0.333318C7.795 0.333318 0.333332 7.79499 0.333332 17C0.333332 26.205 7.795 33.6667 17 33.6667C19.5878 33.6686 22.1403 33.067 24.4549 31.9097C26.7694 30.7525 28.7822 29.0714 30.3333 27Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.e9c699c6b6b11beeaa6c2c35a5849be6.svg";
export { ForwardRef as ReactComponent };